import React, { useEffect, useRef, useState } from 'react'
import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.min.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import { Spanish } from 'flatpickr/dist/l10n/es.js'

const DatePickerInput = ({
  id,
  name,
  className = '',
  value,
  onChange,
  placeholder = 'Selecciona una fecha',
  styleBtn = {},
}) => {
  const dateInputRef = useRef(null)
  const [dateValue, setDateValue] = useState(value || '')
  const flatpickrInstance = useRef(null)

  useEffect(() => {
    if (dateInputRef.current) {
      flatpickrInstance.current = flatpickr(dateInputRef.current, {
        dateFormat: 'Y-m-d',
        locale: Spanish,
        defaultDate: value || null, // Inicializa el flatpickr con el valor recibido
        onChange: (selectedDates, dateStr) => {
          const fakeEvent = { target: { value: dateStr } }
          onChange?.(fakeEvent)
          setDateValue(dateStr) // Actualiza el estado con la fecha seleccionada
        },
      })
    }
  }, [value]) // Se actualiza cuando el valor cambie

  // Para manejar cambios de valor fuera del componente
  useEffect(() => {
    if (flatpickrInstance.current && value) {
      flatpickrInstance.current.setDate(value) // Actualiza flatpickr si cambia el valor
    }
  }, [value])

  // Función para limpiar la fecha
  const clearDate = () => {
    if (flatpickrInstance.current) {
      flatpickrInstance.current.clear() // Limpia el datepicker
    }
    setDateValue('') // Limpia el estado
  }

  return (
    <div className="input-group">
      <input
        ref={dateInputRef}
        id={id}
        name={name}
        className={`form-control ${className}`}
        placeholder={placeholder}
        defaultValue={value ?? ''} // `defaultValue` solo para el primer render
      />
      <div className="input-group-append">
        <button
          className="btn btn-outline-secondary"
          style={{...styleBtn}}
          type="button"
          onClick={() => flatpickrInstance.current.open()} // Abre el calendario
        >
          <i className="fas fa-calendar-alt"></i> {/* Ícono de calendario */}
        </button>
        {dateValue && ( // Solo muestra el botón de borrar si hay un valor
          <button
            className="btn btn-outline-secondary"
            style={{...styleBtn}}
            type="button"
            onClick={clearDate} // Llama a la función de limpiar
          >
            <i className="fas fa-times"></i> {/* Ícono de borrar */}
          </button>
        )}
      </div>
    </div>
  )
}

export default DatePickerInput
